import React, { Component } from 'react';
import { getWeek, getDateFromDayByWeek } from '../../Common/Common';
import Top_Bar from '../../Part_Sample/Top_Bar';
import CalendarWithMultiDates from '../../Part_Sample/CalendarWithMultiDates';

export default class Holiday_Calendar_Settings extends Component {
	constructor(props) {
		super(props);
		let specified_dates = [];
		let specified_by_week = [];
		let holiday_info = this.props.param.holiday_info; //contains all the tenant information	
		if (Object.keys(holiday_info).length === 0) { //Check for empty object
			holiday_info.dow = [];
			holiday_info.calendar = { date: {}, dow: {} };
		}

		// Date
		for (let month in holiday_info.calendar.date) {
			for (let day of holiday_info.calendar.date[month]) {
				let new_date = new Date();
				new_date.setHours(0, 0, 0);
				new_date.setMilliseconds(0)
				new_date.setMonth(parseInt(month) - 1); // set the month 
				new_date.setDate(day);
				specified_dates.push(new_date);
			}
		}

		// Day of week
		for (let month in holiday_info.calendar.dow) {
			for (let week in holiday_info.calendar.dow[month]) {
				for (let day of holiday_info.calendar.dow[month][week]) {
					let new_date = new Date();
					new_date.setHours(0, 0, 0);
					new_date.setMilliseconds(0)
					new_date.setMonth(parseInt(month) - 1); // set the month 
					new_date = getDateFromDayByWeek(day, week, month - 1, new_date);
					specified_by_week.push(new_date);
				}
			}
		}

		this.holiday_info = holiday_info;
		this.state = {
			specified_dates: specified_dates,
			specified_by_week: specified_by_week,
		}
	}

	handleChangeDate = (specified_date, specified_by_week) => {
		this.setState({
			specified_dates: specified_date,
			specified_by_week: specified_by_week
		});
	}

	rcvLoadPriceInfo = (price_info) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Unit_Price_Settings', { price_info: price_info == null ? {} : price_info });
	}

	handlePrevious = () => {
		window.app.showLoading();
		this.props.receiver.loadPriceInfo();
	}

	// Save holiday information
	handleRegister = () => {

		let specified_dates = this.state.specified_dates;
		let specified_by_week = this.state.specified_by_week;

		let date = {};
		for (let i in specified_dates) {
			//"date":{month:[day],..},
			let temp_date1 = new Date(specified_dates[i])
			let month = (temp_date1.getMonth() + 1).toString();
			let new_date = temp_date1.getDate();
			if (date[month] == null) date[month] = [];
			date[month].push(new_date);
		}

		let dow = {};
		for (let j in specified_by_week) {
			//"dow":{month:{nth week:[0-6]},...}}
			let temp_date2 = new Date(specified_by_week[j])
			let month = (temp_date2.getMonth() + 1).toString();
			let nth_week = (getWeek(temp_date2)).toString();
			if (dow[month] == null) dow[month] = {};
			if (dow[month][nth_week] == null) dow[month][nth_week] = [];
			dow[month][nth_week].push(temp_date2.getDay());
		}

		let calendar_details = {};
		calendar_details.date = date;
		calendar_details.dow = dow;
		this.holiday_info.calendar = calendar_details;
		this.props.receiver.saveHolidayCalendar(this.holiday_info);
	}

	rcvSaveHolidayCalendar = (response) => {
		if (response != null && response.result == 'OK') this.handlePrevious();
	}

	render() {

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let cal_height = this.props.height - 305;
		if (cal_height < 200) cal_height = 200;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString("calendar")}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ marginLeft: 20, marginTop: 20, }}>
						<CalendarWithMultiDates
							top={0}
							left={0}
							width={this.props.width - 40}
							height={cal_height}
							handleChangeDate={this.handleChangeDate}
							specified_dates={this.state.specified_dates}
							specified_by_week={this.state.specified_by_week}
							style={{ zIndex: 0, }}
							is_calendar_changed={true}
							receiver={this.props.receiver}
						/>
					</div>
				</div>
			</div>
		)
	}
}